import { post } from "@rails/request.js";

/**
 * Create a new Vercel project for a site.
  * @param {string} salug - The name of the site.
  * @param {string} newVercelProject - The name of the new Vercel project.
 * @returns {Promise<any>} The JSON response from the server.
 */
export async function createVercelProject(slug: string, newVercelProject: string) {
  const response = await post(`/sites/${slug}/vercel_projects.json`, {
    body: JSON.stringify({ site: { new_vercel_project: newVercelProject } }),
    contentType: "application/json",
    responseKind: "json"
  });
  return await response.json;
}
